<template>
  <div class="vital-signs-summary small-text">
    <template v-if="s">
      <div>
        BP
        <b :class="bpClass">{{
          s.bp ? `${s.bp.systolic}/${s.bp.diastolic}` : "ไม่ได้วัด"
        }}</b>
        <span v-if="s.firstBp" class="text-muted"
          >(ครั้งแรก {{ s.firstBp.systolic }}/{{ s.firstBp.diastolic }})</span
        >
        · P <b>{{ show(s.pulse) }}</b> · T <b>{{ show(s.tempC) }}</b> · SpO₂
        <b>{{ show(s.spo2, "%") }}</b> · Wt <b>{{ show(s.weightKg) }}</b> · Ht
        <b>{{ show(s.heightCm) }}</b> · BMI <b>{{ show(s.bmi) }}</b>
      </div>
      <div v-if="s.measuredBy" class="description text-muted">
        วัดโดย {{ s.measuredBy }} {{ time(s.measuredDt) }}
      </div>
    </template>
    <span v-else class="text-muted">Vital signs: ไม่ได้บันทึก</span>
  </div>
</template>

<script>
import moment from "moment";
import { summarizeVitals } from "@/utils/vitalSigns";

export default {
  name: "VitalSignsSummary",
  props: {
    readings: { type: Array, default: () => [] },
  },
  computed: {
    s() {
      return summarizeVitals(this.readings);
    },
    bpClass() {
      if (!this.s || !this.s.bp) return "";
      return {
        "vs-sum-warning": this.s.bp.level === "warning",
        "vs-sum-danger": this.s.bp.level === "danger",
      };
    },
  },
  methods: {
    show(v, unit = "") {
      return v === null || v === undefined ? "ไม่ได้วัด" : `${v}${unit}`;
    },
    time(dt) {
      return dt ? moment(dt).format("HH:mm") : "";
    },
  },
};
</script>

<style scoped>
.vs-sum-warning {
  background-color: #fff3cd;
  padding: 0 3px;
}
.vs-sum-danger {
  background-color: #f8d7da;
  padding: 0 3px;
}
</style>
